module.exports = __webpack_public_path__ + "images/common/top_large_ogp_c45569e77c7d68f4af1723525b94ae1d.jpg";